import { create } from 'zustand'
import { formularioCategoriaOrdenSlice } from './slices/categoriaOrdenSlice'

const useCategoriaOrdenStore = create((set, get) => ({
    isLoading: true,
    sucursalesOrden: [],
    sucursales: [],
    categoriasOrden: [],
    categoriasOrdenTemp: [],
    handleSucursales: (e) => {
      set({ sucursalesOrden: e ? [e] : [] });
    },
    handleCategoriasOrden: (newList) => {
      const currentBranch = get().sucursalesOrden[0]?.value;
      if (!currentBranch || !Array.isArray(newList)) return;

      const updatedBranchList = newList.map((item, index) => ({
        ...item,
        branchId: currentBranch,
        orden: index + 1,
      }));

      const otherBranches = get().categoriasOrdenTemp.filter(
        (c) => String(c.branchId) !== String(currentBranch)
      );

      set({
        categoriasOrdenTemp: [...otherBranches, ...updatedBranchList],
      });
    },
    ...formularioCategoriaOrdenSlice(set, get),
    iniciar: async () => {
      await get().obtenerCategoriaOrden();
    },
    limpiar: () => {
      set({
        isLoading: true,
        sucursalesOrden: [],
        sucursales: [],
        categoriasOrden: [],
        categoriasOrdenTemp: [],
      });
    }
}));
  
export default useCategoriaOrdenStore;